import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AccessoryDescriptionComponent
} from '../../../display-product-data/accessory-description/accessory-description.component';

@Component({
  selector: 'app-overview-editor',
  templateUrl: './overview-editor.component.html',
  styleUrls: ['./overview-editor.component.scss'],
  standalone: false
})
export class OverviewEditorComponent implements OnInit {

  @Input() jsonInput: any;
  @Output() overviewChange = new EventEmitter<any>();

  overviewData: any;
  showEditor = false;
  parseError = '';
  private lastProcessedInput: any = null;
  jsonInputText: string =  '{"title": "",' +
    '"subtitle": "",' +
    '"description": "",' +
    '"images": [],' +
    '"content": []}';

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
    this.loadJson();
  }

  loadJson(): void {
    this.parseError = '';

    try {
      let parsed: any;
      try {
        parsed = JSON.parse(this.jsonInputText);
      } catch (error) {
        try {
          const fixedJson = this.jsonInputText.replace(/'/g, '"');
          parsed = JSON.parse(fixedJson);
        } catch (error2) {
          console.error('JSON parse failed:', error);
          this.parseError = 'Invalid JSON format';
          this.showEditor = false;
          return;
        }
      }

      this.buildForm(parsed);
      this.showEditor = true;

    } catch (err) {
      this.parseError = 'Invalid JSON format: ' + err;
      this.showEditor = false;
    }
  }

  applyChanges(): void {
    this.overviewChange.emit(this.overviewData);
  }

  showOverview(): void {
    this.dialog.open(AccessoryDescriptionComponent, {
      data: {overview: this.overviewData},
    maxHeight: '100vh',
    maxWidth: '90vw',
  });
  }

  private buildForm(data: any): void {
    this.overviewData = JSON.parse(JSON.stringify(data || {}));

    if (!this.overviewData.images) {
      this.overviewData.images = [];
    }
    if (!this.overviewData.content) {
      this.overviewData.content = [];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // When parent passes initial data via @Input, auto-load it and show editor
    if (changes['jsonInput'] && this.jsonInput /* && changes['jsonInput'].firstChange */) {
      this.jsonInputText = JSON.stringify(this.jsonInput, null, 2);
      // Automatically build form and show editor on first change
      this.buildForm(this.jsonInput);
      this.showEditor = true;
    }
  }

  get images(): any[] {
    return this.overviewData?.images || [];
  }

  get content(): any[] {
    return this.overviewData?.content || [];
  }

  addNewSection() {
    this.content.push({title:''})
  }

  addItem(sectionIndex: number): void {
    if (!this.content[sectionIndex].itemList) {
      this.content[sectionIndex].itemList = [];
    }
    this.content[sectionIndex].itemList.push('');
  }

  removeItem(sectionIndex: number, itemIndex: number): void {
    this.content[sectionIndex].itemList.splice(itemIndex, 1);
  }

  addTableRow(sectionIndex: number): void {
    if (!this.content[sectionIndex].tableRows) {
      this.content[sectionIndex].tableRows = [['']];
      return;
    }
    let a = Array.from(' '.repeat(this.content[sectionIndex].tableRows[0].length));
    this.content[sectionIndex].tableRows.push(a);
    console.log(a, this.content[sectionIndex].tableRows[0].length, this.content[sectionIndex].tableRows[0][0].length)
  }

  addTableColumn(sectionIndex: number): void {
    if (!this.content[sectionIndex].tableRows) {
      this.content[sectionIndex].tableRows = [];
    }
    this.content[sectionIndex].tableRows.forEach((row: string[])=> row.push(''));
  }

  removeRow(sectionIndex: number, rowIndex: number): void {
    this.content[sectionIndex].tableRows.splice(rowIndex, 1);
  }

  removeColumn(sectionIndex: number, columnIndex: number): void {
    this.content[sectionIndex].tableRows.forEach((row: string[])=> row.splice(columnIndex, 1));
  }
}

